import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../../common/EditPage';
import Panel from '../../../../common/layout/Panel'
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const VoiceRateCreate = () => {

    const [loading, setLoading] = useState(true);
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const [data, setData] = useState({
        'name': '',
        'description': '',
    });

    const handleSave = () => {
        create('/admin/products/voice/rates', {data: data})
            .then(response => {
                toast.success('Voice Rate Table created successfully');
                navigate(`/products/voice/rates`);
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    const handleCancel = () => {
        navigate('/products/voice/rates');
    }


    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    
    return (<> 
        <Panel title = "Voice Rate">
            <div>
                <ToastContainer />
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Voice Rate Table">
                    <EditPagePanel>
                        <EditPageTextField label="Name" nullable id="name" onChange={ onChange } value={ data.name } />
                        <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                   </EditPagePanel>
                </EditPage>
            </div>
        </Panel>
        </>
    )
}   

export default VoiceRateCreate;